var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMicOff28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.742 4.969c-.315-.394-.362-.953-.03-1.332a4.8 4.8 0 0 1 8.41 3.163v6c.001.949-1.033 1.322-1.657.545l-6.723-8.376Zm10.215 12.726c.448.558 1.301.557 1.662-.061a9.54 9.54 0 0 0 .996-2.41c.166-.641-.35-1.224-1.012-1.224-.54 0-.991.395-1.144.912a7.395 7.395 0 0 1-.587 1.421c-.235.436-.225.976.085 1.363Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.523 12.8c0 2.992 2.845 5.288 5.748 4.706l1.78 2.218a7.443 7.443 0 0 1-9.864-4.812C7.034 14.395 6.583 14 6.043 14c-.661 0-1.178.583-1.012 1.223a9.608 9.608 0 0 0 8.212 7.117v2.58a1.08 1.08 0 1 0 2.16 0v-2.58a9.536 9.536 0 0 0 3.049-.87l2.349 2.926a1.08 1.08 0 0 0 1.684-1.352L7.845 4.804a1.08 1.08 0 1 0-1.684 1.352l3.362 4.19V12.8Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicOff28);
export default __webpack_public_path__ + "static/media/mic_off_28.abedc797.svg";
export { ForwardRef as ReactComponent };